module.exports = __webpack_public_path__ + "static/img/quizzort_cat_inner_bg.bab439ba.png";